import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Grid,
    CircularProgress,
    Box,
    IconButton,
    Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { getUserListings } from '../services/api';
import ListingCard from '../components/ListingCard';
import { StyledButton } from '../components/StyledComponents';

const StyledContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
}));

function MyListings() {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchUserListings();
    }, []);

    const fetchUserListings = async () => {
        try {
            setLoading(true);
            const response = await getUserListings();
            setListings(response.data);
        } catch (err) {
            console.error('Error fetching user listings:', err);
            setError('Failed to load your listings. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleEditListing = (id, event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate(`/my-listings/${id}`);
    };

    if (loading) {
        return (
            <StyledContainer>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <CircularProgress />
                </Box>
            </StyledContainer>
        );
    }

    if (error) {
        return (
            <StyledContainer>
                <Typography color="error">{error}</Typography>
            </StyledContainer>
        );
    }

    return (
        <StyledContainer>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h4" component="h1">
                    My Listings
                </Typography>
                <StyledButton
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="/create-listing"
                    startIcon={<AddIcon />}
                >
                    Add Listing
                </StyledButton>
            </Box>
            <Grid container spacing={3}>
                {listings.map((listing) => (
                    <Grid item xs={12} sm={6} md={4} key={listing.id}>
                        <Box position="relative">
                            <ListingCard
                                listing={listing}
                                showWishlist={false} // Disable wishlist functionality
                            />
                            <Tooltip title="Edit Listing">
                                <IconButton
                                    size="small"
                                    onClick={(event) => handleEditListing(listing.id, event)}
                                    aria-label="edit"
                                    sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 255, 255, 1)',
                                        },
                                    }}
                                >
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </StyledContainer>
    );
}

export default MyListings;
